export default "__VITE_ASSET__B1G5M7rP__"